import { render, staticRenderFns } from "./ScreeningProcessNotifications.vue?vue&type=template&id=3afe934e&scoped=true&"
import script from "./ScreeningProcessNotifications.vue?vue&type=script&lang=js&"
export * from "./ScreeningProcessNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afe934e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VAlert,VCard,VCardText})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3afe934e')) {
      api.createRecord('3afe934e', component.options)
    } else {
      api.reload('3afe934e', component.options)
    }
    module.hot.accept("./ScreeningProcessNotifications.vue?vue&type=template&id=3afe934e&scoped=true&", function () {
      api.rerender('3afe934e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screen/components/ScreeningProcessNotifications.vue"
export default component.exports